var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { OnInit, EventEmitter, TemplateRef, ElementRef } from '@angular/core';
import { GalleryColumns } from 'src/app/gallery/models/gallery-list-columns.enum';
var GalleryCardsComponent = /** @class */ (function () {
    function GalleryCardsComponent() {
        this.galleryColumns = GalleryColumns;
        this.selectLabel = 'Select';
        this._columns = [
            GalleryColumns.Model,
            GalleryColumns.Tags,
            GalleryColumns.CreatedBy,
            GalleryColumns.UpdatedBy,
            GalleryColumns.Actions
        ];
        this.checkable = false;
        this.checkedResults = [];
        this.showActions = false;
        this.checkedChange = new EventEmitter();
        this.selectBookmark = new EventEmitter();
    }
    Object.defineProperty(GalleryCardsComponent.prototype, "columns", {
        get: function () {
            return this._columns;
        },
        set: function (value) {
            this._columns = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GalleryCardsComponent.prototype, "results", {
        get: function () {
            return this._results;
        },
        set: function (value) {
            this._results = value;
        },
        enumerable: true,
        configurable: true
    });
    GalleryCardsComponent.prototype.ngOnInit = function () {
    };
    GalleryCardsComponent.prototype.handleSelect = function (result) {
        this.selectBookmark.emit(result);
    };
    GalleryCardsComponent.prototype.handleCheckedChange = function (value) {
        var ids = (value.checked) ? __spread(this.checkedResults, [value.id]) : this.checkedResults.filter(function (id) { return id !== value.id; });
        this.checkedChange.emit(ids);
    };
    GalleryCardsComponent.prototype.isChecked = function (id) {
        return this.checkedResults.indexOf(id) >= 0;
    };
    return GalleryCardsComponent;
}());
export { GalleryCardsComponent };
